import React from 'react';
import { t } from '@lingui/macro';
import styled from 'styled-components';
import {
    Progress,
    Box,
    Badge,
    fontWeight,
    spacing,
    palette,
    radius,
} from '@landr/maestro';
import { useUserCreditsContext } from 'contexts/UserCreditsContext/UserCreditsContext';
import isNumber from 'lodash/isNumber';

const StyledBadge = styled(Badge)`
    font-weight: ${fontWeight('bold')};
    cursor: pointer;
    height: ${spacing('lg')};
    vertical-align: middle;
`;

const StyledLoadingBadge = styled(Box)`
    display: inline-flex;
    height: ${spacing('lg')};
    background-color: ${palette('primary.500')};
    vertical-align: middle;
    border-radius: ${radius('round')};
    text-align: center;
    padding: 4.5px 8px;
`;

const LoadingBadge = () => (
    <StyledLoadingBadge>
        <Progress size={11} />
    </StyledLoadingBadge>
);

const BalanceBadge = ({ userCredits }: { userCredits: number }) => {
    const credits = userCredits?.toString(10);
    const content = t({
        comment: '"cr." is the abbreviation of "credit"',
        message: `${credits} cr.`,
    });

    return (
        <StyledBadge
            aria-label="User Credit Count"
            size="md"
            kind="subtle"
            variant="primary"
            isRounded
            showZero={true}
            max={9999}
            content={content}
        />
    );
};

const RemainingCredits: React.FC = () => {
    const { userCredits } = useUserCreditsContext();

    const isUserCreditsDefined = isNumber(userCredits);

    return (
        <>
            {isUserCreditsDefined ? (
                <BalanceBadge userCredits={userCredits} />
            ) : (
                <LoadingBadge />
            )}
        </>
    );
};

export default RemainingCredits;
